<template>
  <GlobalWindow :title="title" :visible.sync="visible" :confirm-working="isWorking" @confirm="confirm">
    <el-form :model="form" ref="form" :rules="rules">
      <el-form-item label="用户ID" prop="userId"><el-input v-model="form.userId" placeholder="用户ID" /></el-form-item>
      <el-form-item label="日记ID" prop="diaryId"><el-input v-model="form.diaryId" placeholder="日记ID" /></el-form-item>
      <el-form-item label="情绪值" prop="moodValue"><el-input v-model="form.moodValue" placeholder="情绪值" /></el-form-item>
      <el-form-item label="情绪标签" prop="moodLabel"><el-input v-model="form.moodLabel" placeholder="情绪标签" /></el-form-item>
      <el-form-item label="图标" prop="moodIcon"><el-input v-model="form.moodIcon" placeholder="图标" /></el-form-item>
      <el-form-item label="日期" prop="recordDate"><el-input v-model="form.recordDate" placeholder="日期" /></el-form-item>
    </el-form>
  </GlobalWindow>
</template>
<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'operauserMoodWindow', extends: BaseOpera, components: { GlobalWindow },
  data() { return { form: { id: null, userId: '', diaryId: '', moodValue: '', moodLabel: '', moodIcon: '', recordDate: '' }, rules: {} } },
  created() { this.config({ api: '/rentHouse/userMood', 'field.id': 'id' }) }
}
</script>